import React from 'react';
import { Link } from 'react-router-dom';
import CheckboxInput from '../CheckboxInput';

const prettifyStatus = (status) => {
  if (status === 'pending_arrangement') {
    return 'pending arrangement';
  } else if (status === 'denied_arrangement') {
    return 'denied';
  } else {
    return status;
  }
};

const PendingArrangementList = ({
  purchases,
  selected,
  handleCheckboxClick,
}) => (
  <table className="table table-striped mar-t">
    <thead>
      <tr>
        <td></td>
        <td>ID</td>
        <td>Name</td>
        <td>Arranged Charge Date</td>
        <td>Total</td>
        <td>Card ID</td>
        <td>Status</td>
        <td></td>
      </tr>
    </thead>
    <tbody>
      {purchases &&
        purchases.map((purchase) => (
          <tr key={purchase.id}>
            <td className="arrangement-checkbox-wrapper">
              <CheckboxInput
                input={{
                  checked: selected.includes(purchase.id),
                  onChange: () => handleCheckboxClick(purchase.id),
                }}
              />
            </td>
            <td>{purchase.id}</td>
            <td>
              {purchase.first_name} {purchase.last_name}
            </td>
            <td>{purchase.arranged_charge_date}</td>
            <td>{purchase.cost.total}</td>
            <td>{purchase.charge_card}</td>
            <td>{prettifyStatus(purchase.status)}</td>
            <td>
              <Link to={`/purchases/${purchase.id}/view`}>View</Link>
            </td>
          </tr>
        ))}
      {purchases && purchases.length === 0 && (
        <tr>
          <td className="text-center" colSpan="7">
            No Results
          </td>
        </tr>
      )}
    </tbody>
  </table>
);

export default PendingArrangementList;
